import { Box } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

export const FooterButtonGroup = ({
  tc,
  actionButtonId,
  actionButtonLabel,
  actionButtonDisabled,
  actionButtonType,
  actionButtonOnClick,
  cancelButtonOnClick,
}) => {
  return (
    <div className="CVDialogFooter">
      <button id={actionButtonId} className="btn btn-primary" disabled={actionButtonDisabled} type={actionButtonType} onClick={actionButtonOnClick}>
        <Box fontWeight="bold">{tc(actionButtonLabel)}</Box>
      </button>
      <button id="cancelButton" className="btn btn-outline" disabled={false} onClick={cancelButtonOnClick}>
        <Box fontWeight="bold">{tc('BUTTON_CANCEL')}</Box>
      </button>
    </div>
  );
};

FooterButtonGroup.propTypes = {
  tc: PropTypes.func,
  actionButtonId: PropTypes.string,
  actionButtonLabel: PropTypes.string,
  actionButtonDisabled: PropTypes.bool,
  actionButtonType: PropTypes.string,
  actionButtonOnClick: PropTypes.func,
  cancelButtonOnClick: PropTypes.func,
};